import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class TimeslotPickerService {
    constructor(private http: HttpClient) { }

    public  monthChangeSubject$:BehaviorSubject<any>=new BehaviorSubject('');
    readonly monthChange$: Observable<any> = this.monthChangeSubject$.asObservable();

    monthChanged(data){
        this.monthChangeSubject$.next(data);
    }

    getTimeslots(id, params): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/products/get-available-timings/${id}`, { date:params});
      }
}
